module.exports = __webpack_public_path__ + "img/pic5.6a56eb4f.png";